import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { app } from "../config/firebase";

/**
 * Serviço de Integração Frontend -> Backend para o Motor da ClickSign
 * @param {string} requestId - ID da Solicitação/Ficha no Firestore
 * @returns {Promise<any>} Resposta da Cloud Function
 */
export const gerarEnvelopeClickSign = async (requestId) => {
  const functions = getFunctions(app);

  if (window.location.hostname === "localhost") {
    connectFunctionsEmulator(functions, "localhost", 5001);
  }

  const createClickSignEnvelope = httpsCallable(functions, "createClickSignEnvelope");

  // 🚀 BLINDAGEM DE AMBIENTE: Detecta localhost OU URL de homologação na nuvem
  const isHomolog = window.location.hostname === "localhost" || window.location.hostname.includes("homolog");

  try {
    const response = await createClickSignEnvelope({
      requestId,
      environment: isHomolog ? "homolog" : "production"
    });
    
    return /** @type {any} */ (response.data);
  } catch (error) {
    console.error("[ClickSign Service] Erro ao chamar o Motor:", error);
    throw error;
  }
};